import { Injectable } from '@angular/core';
import { createSelector, select, Store } from '@ngrx/store';
import { map, Observable } from 'rxjs';

import { TimelineItemEntity } from '../components/timeline-list/timeline-item.entity';
import { TimelineListEntity } from '../components/timeline-list/timeline-list.entity';
import { featureSelector, TimelineRootState } from './feature.store';
import { TimelineMainSliceState, TimelineSliceKey } from './timeline.state';

const baseSelector = createSelector(
	featureSelector,
	(state) => state[TimelineSliceKey]
);

const listSelector = createSelector(baseSelector, (state) => state.list);

// eslint-disable-next-line @typescript-eslint/explicit-function-return-type
const timelineById = (id: number) =>
	createSelector(listSelector, (list) => list.elements.get(`${id}`));

@Injectable()
export class TimelineSelector {
	public constructor(private readonly store: Store<TimelineRootState>) {}

	private get state(): Observable<TimelineMainSliceState> {
		return this.store.pipe(select(baseSelector));
	}

	public getLoading$(): Observable<boolean> {
		return this.state.pipe(map((state) => state.get('loading')));
	}

	public getTimelineList$(): Observable<TimelineListEntity> {
		return this.store.pipe(select(listSelector));
	}

	public getIncludePublic$(): Observable<boolean> {
		return this.state.pipe(map((state) => state.get('includePublicProjects')));
	}

	public getTimeline$(id: number): Observable<TimelineItemEntity | undefined> {
		return this.store.pipe(select(timelineById(id)));
	}

	public getSuccessDeleteTimeline$(): Observable<boolean> {
		return this.state.pipe(map((state) => state.get('deleteSuccess')));
	}

	public getSelectedTimelines$(
		selected: Array<string>
	): Observable<Array<TimelineItemEntity>> {
		return this.getTimelineList$().pipe(
			map((list) =>
				selected.reduce<Array<TimelineItemEntity>>((acc, curr) => {
					const maybe = list.elements.get(`${curr}`);
					if (maybe) {
						acc.push(maybe);
						return acc;
					}
					return acc;
				}, [])
			)
		);
	}
}
